// extracted by mini-css-extract-plugin
export default {"notesPopupImportant":"AddNotesPopupButton_notesPopupImportant__8pJhj"};